import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import NotificationTypeCreate from 'components/NotificationType/Create';

const ScreenNotificationTypeCreate = ({ classes }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <NotificationTypeCreate />
      </GridItem>
    </GridContainer>
  </div>
);

ScreenNotificationTypeCreate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenNotificationTypeCreate);
